/**
 * Labstep
 *
 * @desc Imports (lazy) import action in error boundary
 */

import { ResourceItemActionBulkCreateModalContainer as ResourceItemActionBulkCreateModal } from 'labstep-web/components/ResourceItem/Action/BulkCreate/Modal';
import { ICONS } from 'labstep-web/constants/icons';
import { ErrorBoundaryContainer } from 'labstep-web/containers/ErrorBoundary';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ResourceItem } from 'labstep-web/models/resource-item.model';
import type React from 'react';
import { Suspense } from 'react';
import type { ResourceItemActionImportContainerProps } from './types';

export const ResourceItemActionImport: React.FC<
  ResourceItemActionImportContainerProps
> = (props) => (
  <ErrorBoundaryContainer FallbackComponent={<div />}>
    <Suspense
      fallback={
        <ActionComponent
          type="text"
          icon={ICONS.resource_item.primary}
          text={`Add ${ResourceItem.getHumanReadableEntityName(
            true,
            true,
            props.resource.is_template,
          )}`}
          {...(props.actionComponentProps as any)}
          elementProps={{
            ...props.actionComponentProps?.elementProps,
            disabled: true,
          }}
        />
      }
    >
      <ResourceItemActionBulkCreateModal {...props} />
    </Suspense>
  </ErrorBoundaryContainer>
);
